"use client";

import React from "react";
import type { IconProps } from "@/components/icons/icons-utils/icon-props";
import { useIconLayout } from "@/components/icons/icons-utils/use-icon-layout";

// MARK: SpinnerThird
/**
 * SpinnerThird icon — add SVG markup inside the root `<svg>`.
 *
 * **Reuse scope:** Project-wide — `@/components/icons` registry.
 */
export const SpinnerThird: React.FC<IconProps> = (props) => {
    const { resolved_width, resolved_height, effective_stroke_width, className, svg_style, rest } = useIconLayout(props);

    return (
        <svg
            viewBox="0 0 24 24"
            width={resolved_width}
            height={resolved_height}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            style={svg_style}
            strokeWidth={effective_stroke_width}
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden
            {...rest}
        >
            {/* Add paths or groups (e.g. stroke="currentColor" for strokes). */}
        </svg>
    );
};

SpinnerThird.displayName = "SpinnerThird";
